// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basket-mobile-layout{background:#fff}.basket-mobile-layout__tabs-holder{border-bottom:1px solid #e6e9ed;display:flex;justify-content:space-between}.basket-mobile-layout__content{padding-top:16px}.basket-mobile-layout__total-button{position:sticky;padding:16px;background-color:hsla(0,0%,100%,.8);z-index:2;bottom:0;transition:background-color .3s}", ""]);
// Exports
module.exports = exports;
